import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type {
  ISaveTranslationsResponse,
} from '../types';
import {
  IMPORT_TRANSLATIONS_URL,
  TRANSLATE_MANAGER_IMPORT_TRANSLATIONS_MUTATION_KEY,
  TRANSLATE_MANAGER_PERMISSIONS,
} from '../constants';

export default function useImportTranslationsMutation(): IContextMutationResult<ISaveTranslationsResponse, Error, FormData> {
  const { fetchPost } = useRestClient();

  return useContextMutation<ISaveTranslationsResponse, Error, FormData>({
    mutationKey: [TRANSLATE_MANAGER_IMPORT_TRANSLATIONS_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<ISaveTranslationsResponse>(IMPORT_TRANSLATIONS_URL, payload, {
      permission: TRANSLATE_MANAGER_PERMISSIONS.TRANSLATEMANAGER_EDIT,
    }),
  });
}
